import { render, staticRenderFns } from "./Morebtn.vue?vue&type=template&id=42a12837&scoped=true&"
import script from "./Morebtn.vue?vue&type=script&lang=js&"
export * from "./Morebtn.vue?vue&type=script&lang=js&"
import style0 from "./Morebtn.vue?vue&type=style&index=0&id=42a12837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a12837",
  null
  
)

export default component.exports